import { AddCashFundDialogFields } from './types';
import { CookedProduct, isPricedProduct, isCustomDonationFundItemNoGoal, CookedProductCatalogItem } from '@apps/registry/common/selectors/ProductListSelector';

export const DEFAULT_FIXED_AMOUNT = 50;
export const DEFAULT_ANY_AMOUNT = 300;

const calculateTotalGoal = (qty: number, amount: number) => {
  return (amount * 100 * qty * 100) / 10000;
};

export const getTotalGoalFormatted = (qty: number, amount?: number) => {
  const totalNumber: number = amount ? calculateTotalGoal(qty, amount) : 0;
  return totalNumber % 1 === 0 ? totalNumber : totalNumber.toFixed(2);
};

const getMonetaryMinorValueAsInt = (value: number) => {
  return parseInt((value * 100).toString());
};

export const getMonetaryValueFromMinorUnits = (valueInMinorUnits?: number) => {
  return valueInMinorUnits ? valueInMinorUnits / 100 : 0;
};

export const getPrefixOffset = (amount?: number | null, qty?: number) => {
  const multiplier = qty ?? 1;
  return amount && amount ? (amount * multiplier).toString().length * 10 : 30;
};

export const calculateDonationFundValuesFromFields = (addCashFundDialogFields: AddCashFundDialogFields) => {
  const { amount, qty, isAnyAmountSelected, isGoalHidden, enableCashOrCheck, enableJoyCredit } = addCashFundDialogFields;
  const suggestedDonationMonetaryMinorValue = !isAnyAmountSelected && amount ? getMonetaryMinorValueAsInt(amount) : null;
  const goalMonetaryMinorValue =
    !isAnyAmountSelected && amount ? getMonetaryMinorValueAsInt(calculateTotalGoal(amount, qty)) : isAnyAmountSelected && amount ? getMonetaryMinorValueAsInt(amount) : 0;
  const donationsAreCapped = !isAnyAmountSelected;
  const enforceSuggestedDonationAmount = !isAnyAmountSelected;
  const hideFundingGoal = !!(isAnyAmountSelected && isGoalHidden);

  return {
    goalMonetaryMinorValue,
    suggestedDonationMonetaryMinorValue,
    donationsAreCapped,
    enforceSuggestedDonationAmount,
    hideFundingGoal,
    enableCashOrCheck: addCashFundDialogFields.isLinkToCharitySelected ? false : enableCashOrCheck,
    enableJoyCredit: addCashFundDialogFields.isLinkToCharitySelected ? false : enableJoyCredit,
  };
};

export const getInitialAmountAndCurrency = (
  cashFundCurrencyCode: string,
  isAnyAmountSelectedByDefault: boolean,
  cashFundProduct?: Maybe<CookedProduct | CookedProductCatalogItem>,
  lastUsedAmount?: number,
) => {
  let amount = undefined;

  if (isCustomDonationFundItemNoGoal(cashFundProduct)) {
    amount = undefined;
  } else if (isPricedProduct(cashFundProduct)) {
    amount = cashFundProduct.numberPrice;
  } else {
    amount = isAnyAmountSelectedByDefault ? DEFAULT_ANY_AMOUNT : lastUsedAmount ? getMonetaryValueFromMinorUnits(lastUsedAmount) : DEFAULT_FIXED_AMOUNT;
  }

  return {
    currencyCode: cashFundCurrencyCode,
    amount,
  };
};
